import type { FaireProductEntity } from "../../entity_types/product";

export const p_r92h762x2f: FaireProductEntity = {
  token: "p_r92h762x2f",
  type: "product",
  name: "Blessed Virgin Mary 18K Gold Charm Religious Charm , CP1550",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/1d38f1730298516c75f85f834fe4fe23f8fdc80ae21d02557b15ca1de27c986b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44c4dcecea3bf1119b4f5511e81aa8c17b8ee29b5f661174f90550353313637e.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "Description:\nMaterial: Brass Based with 18K Gold Filled, Cubic Zirconia\nSize: 27x17mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\nThank you for your visit!\n\nCARE INSTRUCTIONS\n\nTo care for your delicate jewelry and maintain its quality and longevity, please follow these guidelines:\n\n- Avoid contact with chemical solutions, perfumes, sweat, and saltwater/chlorine.\n- Use a soft, damp cloth to wipe off your jewelry regularly.\n- Keep your jewelry dry to prevent tarnishing.\n- Store different types of jewelry separately in a sealed bag to prevent oxidization.\n\n***These items do come in larger quantities than listed. Please message me for a custom wholesale amount.",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:43.275Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
